import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import * as dashboardService from "../services/dashboard.services";
import { useTranslation } from "react-i18next";
import Loader from "../common/loader";
import Sorting from "../common/sorting";
import { capitalizeFirstLetter, formateDateWithMonth } from "../../../utils/commonfunction";
import CustomPagination from "../common/custompagination";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { LOADER_TIMEOUT_TIME } from "../../../utils/Constants";

const Dashboard = () => {
    const [showDashboardCount, setShowDashboardCount] = useState({});
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");

    const { t } = useTranslation();

    useEffect(() => {
        dashboardService
            .Counts()
            .then((response) => {
                setShowDashboardCount(response && response.data ? response.data : {});
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, []);

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);

                dashboardService
                    .recentEarningList(formData)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        // setSerialNo(data.data.offset);
                        setList(data && data.data && data.data.list ? data.data.list : []);
                        //   console.log("data.data.data_ids", data.data.data_ids);

                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                        setLoader(false);
                    });
            }
        }, 500);
        return () => clearTimeout(getData);
    }, [location, statsupdate, sorting, search, globalsearch, itemperpage, params.pgno]);

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    };

    const resetFilter = (e) => {
        e.preventDefault();
        setGlobalSearch("");
        prepareSearch();
        setSearch({});
        // setResetDate(!resetdate);
        // $("#defaultstatus")[0].selectedIndex = 0;
    };

    const formatCurrency = (num) => {
        if (!num || isNaN(num)) return "₹0.00";
        if (num > 1e15) return "₹999.99T+";

        if (num >= 1e12) return "₹" + (num / 1e12).toFixed(2) + "T";
        if (num >= 1e9) return "₹" + (num / 1e9).toFixed(2) + "B";
        if (num >= 1e6) return "₹" + (num / 1e6).toFixed(2) + "M";
        if (num >= 1e3) return "₹" + (num / 1e3).toFixed(2) + "K";

        return "₹" + num.toFixed(2);
    };

    return (
        <>
            <div className="row row-sm animation_fade">
                <div className="col-sm-12 col-lg-12 col-xl-12">
                    <div className="row row-sm">
                        <div className="col-12 col-md-6 col-xl-3 mb-3">
                            <div className="card custom-card h-100">
                                <div className="card-body cp">
                                    <Link to={`/admin/dashboard/1`}>
                                        <div className="card-item d-flex align-items-center">
                                            <div className="card-item-icon card-icon cp me-3">
                                                <i className="fa fa-money-bill sidemenu-icon" style={{ fontSize: "20px" }}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <div className="card-item-title mb-2">
                                                    <label className="main-content-label tx-13 font-weight-bold mb-1">Total Commission</label>
                                                </div>
                                                <div className="card-item-body">
                                                    <div className="card-item-stat">
                                                        <h4
                                                            className="font-weight-bold text-truncate mb-0"
                                                            title={showDashboardCount?.totalCommission?.toFixed(2) || "₹0.00"}
                                                            style={{ maxWidth: "100%" }}
                                                        >
                                                            {showDashboardCount?.totalCommission ? formatCurrency(showDashboardCount.totalCommission) : "₹0.00"}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/dashboard/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        <i className="fa fa-money-bill sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          Total Commission
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.totalCommission
                              ? '₹' + ' ' +(showDashboardCount.totalCommission).toFixed(2)
                              : "₹0.00"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>  */}

                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div className="card custom-card">
                                <div className="card-body cp">
                                    <Link to={`/admin/center-management/center/list/1`}>
                                        <div className="card-item">
                                            <div className="card-item-icon card-icon cp ">
                                                <i className="fa fa-building sidemenu-icon" style={{ fontSize: "20px" }}></i>
                                            </div>
                                            <div className="card-item-title mb-2">
                                                <label className="main-content-label tx-13 font-weight-bold mb-1">Total Centres</label>
                                            </div>
                                            <div className="card-item-body">
                                                <div className="card-item-stat">
                                                    <h4 className="font-weight-bold">{showDashboardCount && showDashboardCount.centers ? showDashboardCount.centers : "0"}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/doctor-management/doctor/list/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        <i className="fa fa-user-md sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          Total Doctors
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.doctors
                              ? showDashboardCount.doctors
                              : "0"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div> */}
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div className="card custom-card">
                                <div className="card-body cp">
                                    <Link to={`/admin/customer-management/customer/list/1`}>
                                        <div className="card-item">
                                            <div className="card-item-icon card-icon cp ">
                                                <i className="fa fa-user sidemenu-icon" style={{ fontSize: "20px" }}></i>
                                            </div>
                                            <div className="card-item-title mb-2">
                                                <label className="main-content-label tx-13 font-weight-bold mb-1">Total Customers</label>
                                            </div>
                                            <div className="card-item-body">
                                                <div className="card-item-stat">
                                                    <h4 className="font-weight-bold">{showDashboardCount && showDashboardCount.customers ? showDashboardCount.customers : "0"}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                            <div className="card custom-card">
                                <div className="card-body cp">
                                    <Link to={`/admin/coach-management/list/1`}>
                                        <div className="card-item">
                                            <div className="card-item-icon card-icon cp ">
                                                <i className="fas fa-chalkboard-teacher sidemenu-icon" style={{ fontSize: "20px" }}></i>
                                            </div>
                                            <div className="card-item-title mb-2">
                                                <label className="main-content-label tx-13 font-weight-bold mb-1">Total Coaches</label>
                                            </div>
                                            <div className="card-item-body">
                                                <div className="card-item-stat">
                                                    <h4 className="font-weight-bold">{showDashboardCount && showDashboardCount.coaches ? showDashboardCount.coaches : "0"}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h6 className="main-content-label">Recent Earnings</h6>
                                <div className="d-flex align-items-center">
                                    <div className="form-group mb-0 me-3">
                                        <div className="form-group mb-0 rangepicker_container filter_design">
                                            <i className="fa fa-search calender_icon"></i>
                                            <input
                                                type="search"
                                                className="form-control"
                                                value={globalsearch}
                                                placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                                                onChange={(e) => {
                                                    setGlobalSearch(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-warning float-right mr-2">
                                        {t("admin.filter_placeholder.btn_reset_filter")}
                                    </button>
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                    <thead>
                                        <tr>
                                            <th>Transaction ID</th>
                                            <th>Centre Name</th>
                                            <th>Centre Register ID</th>
                                            <th>Amount</th>
                                            <th>Created At</th>
                                            {/* <th className="">{t("Transaction Type")}</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loader ? (
                                            <tr>
                                                <td colSpan={14}>
                                                    <Loader />
                                                </td>
                                            </tr>
                                        ) : (
                                            <>
                                                {list.length ? (
                                                    list.map((row, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{row?.transaction_id ? row?.transaction_id : "-"}</td>
                                                                <td>{capitalizeFirstLetter(row?.center_name)}</td>
                                                                <td>{row?.center_register_id ? "#" + row?.center_register_id : "-"}</td>
                                                                <td>{row?.amount ? "₹" + " " + row?.amount.toFixed(2) : "0.00"}</td>
                                                                {/* <td>{capitalizeFirstLetter(row?.transaction_type)}</td> */}
                                                                {/* <td>{row.createdAt}</td> */}
                                                                <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={14} className="text-center">
                                                            {t("admin.message.msg_no_records")}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="" id="example1_info" role="status" aria-live="polite">
                                <b>
                                    {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
                                </b>
                            </div>
                            {datalength && datalength > 0 ? (
                                <CustomPagination
                                    datalength={datalength}
                                    itemperpage={itemperpage}
                                    currentPage={page}
                                    setPage={setPage}
                                    pageRoute={[
                                        {
                                            name: "Medicine Management",
                                            path: "/admin/dashboard",
                                        },
                                    ]}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;
